import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDBTeV1PMO196cMcp4YvDP1q-0n_MSk7pE",
  authDomain: "aprovado-6455c.firebaseapp.com",
  projectId: "aprovado-6455c",
  storageBucket: "aprovado-6455c.firebasestorage.app",
  messagingSenderId: "246875015214",
  appId: "1:246875015214:web:fc94e7c0cc65bb3b7d77bf"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
